import { useEffect, useState } from "react";

import { Moment } from "moment";

import { useDatePickerRange } from "components/DatePickerRange/hooks";
import { YYYY_MM_DD, YYYY_MM_DD_HH_mm_ss } from "shared";

import { SCHEDULE_TASK_TYPE, ScheduledDatePayload } from "../../../types";

const useScheduleDate = (
    scheduleType: SCHEDULE_TASK_TYPE | null,
    change: (data: ScheduledDatePayload) => void
) => {
    const { parseDateToUtc, parseDate } = useDatePickerRange();

    const [startDate, setStartDate] = useState<Moment | null>(null);
    const [endDate, setEndDate] = useState<Moment | null>(null);

    useEffect(() => {
        selectStartDate(null);
        selectEndDate(null);
    }, [scheduleType]);

    useEffect(() => {
        change({
            from: parseDateToUtc(startDate, YYYY_MM_DD_HH_mm_ss, true),
            to: parseDateToUtc(endDate, YYYY_MM_DD_HH_mm_ss)
        });
        // eslint-disable-next-line
    }, [startDate, endDate]);

    const selectStartDate = (date: Moment | null) => setStartDate(date);
    const selectEndDate = (date: Moment | null) => setEndDate(date);

    return {
        startDate,
        endDate,
        fromDate: parseDate(startDate, YYYY_MM_DD),
        toDate: parseDate(endDate, YYYY_MM_DD),
        selectStartDate,
        selectEndDate
    };
};

export { useScheduleDate };
